import { range } from 'lodash';
import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import styled from 'styled-components';

type Props = {
  pagination?: {
    current: number;
    max_page: number;
    has_prev: boolean;
    has_next: boolean;
  };
  onChangePage?: (page: number) => void;
};

const defaultPagination = {
  current: 1,
  max_page: 1,
  has_prev: false,
  has_next: false,
};

const Pager = ({ pagination = defaultPagination, onChangePage }: Props) => {
  const { current, max_page, has_prev, has_next } = pagination;

  const pages = range(current + 1, Math.min(current + 9, max_page) + 1);
  const onClickLink =
    (pageTo: number): React.MouseEventHandler<HTMLAnchorElement> =>
    (e) => {
      e.preventDefault();
      onChangePage?.(pageTo);
    };

  return (
    <div>
      <Pagination className="justify-content-center">
        <PaginationItem disabled={!has_prev}>
          <PaginationLink onClick={onClickLink(current - 1)} href="#">
            前のページ
          </PaginationLink>
        </PaginationItem>
        {current !== 1 ? (
          <PaginationItem>
            <PaginationLink onClick={onClickLink(1)} href="#">
              {1}
            </PaginationLink>
          </PaginationItem>
        ) : null}
        {current > 2 ? (
          <PaginationItem disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        ) : null}
        <PaginationItem>
          <PaginationLink>{current}</PaginationLink>
        </PaginationItem>
        {pages.map((page) => (
          <PaginationItem key={page}>
            <PaginationLink onClick={onClickLink(page)} href="#">
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={!has_next}>
          <PaginationLink onClick={onClickLink(current + 1)} href="#">
            次のページ
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default styled(Pager)``;
